import React, { ErrorInfo } from "react";
import ReactDOMClient from "react-dom/client";
import singleSpaReact from "single-spa-react";
import Root from "./root.component";

// console.log("[crm-rlmngt] Initializing single-spa lifecycle");

// ✅ FIX: Enhanced error boundary for React 19 hydration errors
const handleError = (err: Error, errInfo: ErrorInfo) => {
  // console.error("[crm-rlmngt] Error boundary caught:", err, errInfo);

  // Check if it's a hydration/scheduler error
  const isHydrationError =
    err?.message?.includes("push") ||
    err?.message?.includes("hydration") ||
    err?.message?.includes("scheduler");

  return (
    <div
      style={{
        color: "red",
        padding: "20px",
        border: "2px solid red",
        borderRadius: "4px",
        fontFamily: "monospace",
        backgroundColor: "#fff0f0",
      }}
    >
      <h2>⚠️ Error in CRM Application</h2>
      <p>
        <strong>Type:</strong>{" "}
        {isHydrationError ? "Hydration Error" : "Component Error"}
      </p>
      <p>
        <strong>Message:</strong> {err.message}
      </p>
      <details style={{ marginTop: "10px", fontSize: "12px" }}>
        <summary>Details</summary>
        <pre style={{ overflow: "auto", maxHeight: "200px" }}>
          {errInfo.componentStack}
        </pre>
      </details>
      <p style={{ marginTop: "10px", fontSize: "12px" }}>
        Please refresh the page. If the problem persists, contact support.
      </p>
    </div>
  );
};

// ✅ FIX: Wrap initialization with error handling
let lifecycles;
try {
  // console.log("[crm-rlmngt] Creating singleSpaReact instance...");

  lifecycles = singleSpaReact({
    renderType: "createRoot",
    React,
    ReactDOMClient,
    rootComponent: Root,
    errorBoundary: handleError,
  });

  // console.log("[crm-rlmngt] singleSpaReact instance created successfully");
} catch (err) {
  // console.error("[crm-rlmngt] Failed to create singleSpaReact instance:", err);
  throw err;
}

// ✅ FIX: Ensure all lifecycle methods are exported
export const { bootstrap, mount, unmount, update } = lifecycles;

// UserGroups parcel — importable by other MFEs via System.import('@crm/rlmngt')
export {
  bootstrap as UserGroupsBootstrap,
  mount as UserGroupsMount,
  unmount as UserGroupsUnmount,
} from "./pages/UserManagement/UserGroups/UserGroups.parcel";

// console.log("[crm-rlmngt] Lifecycle hooks exported successfully");
